import script from "./DatabaseConfig.vue?vue&type=script&setup=true&lang=ts"
export * from "./DatabaseConfig.vue?vue&type=script&setup=true&lang=ts"

import "./DatabaseConfig.vue?vue&type=style&index=0&id=ec371b8c&scoped=true&lang=less"

import exportComponent from "E:\\twl\\workspace\\auxiliary-ts-cms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec371b8c"]])

export default __exports__